/**
 * VinPOP Subscription Frequency Selector
 * Enhances the Shopify Subscriptions widget with better UX and translations
 */

class VinpopSubscriptionSelector {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupSubscriptionWidget());
    } else {
      this.setupSubscriptionWidget();
    }

    // Also monitor for dynamic content changes (ReCharge loads dynamically)
    this.observeSubscriptionChanges();
  }

  setupSubscriptionWidget() {
    const subscriptionContainer = document.querySelector('#rc_selling_plans_for_subscription, [id*="rc_selling_plans_"]');
    
    if (subscriptionContainer) {
      this.addTranslationAttributes(subscriptionContainer);
      this.enhanceFrequencySelector(subscriptionContainer);
      this.updateButtonText(subscriptionContainer);
    }
  }

  addTranslationAttributes(container) {
    // Get translations from Shopify's translation system
    const frequencyHeading = window.shopify_translations?.subscription?.frequency_heading || 'Delivery frequency';
    const subscriptionText = window.shopify_translations?.subscription?.subscribe_and_save || 'Subscribe and Save';
    
    container.setAttribute('data-frequency-heading', frequencyHeading);
    container.setAttribute('data-subscription-text', subscriptionText);
  }

  enhanceFrequencySelector(container) {
    // Add custom styling classes
    const frequencyOptions = container.querySelectorAll('.rc-selling-plan-group');
    
    frequencyOptions.forEach((option, index) => {
      option.classList.add('vinpop-frequency-option');
      option.setAttribute('data-frequency-index', index);

      // Style the radio buttons and labels
      const radioInputs = option.querySelectorAll('input[type="radio"]');
      const labels = option.querySelectorAll('label');

      radioInputs.forEach(radio => {
        radio.classList.add('vinpop-frequency-radio');
      });

      labels.forEach(label => {
        label.classList.add('vinpop-frequency-label');
      });
    });

    // Add change event listeners
    container.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        this.updateButtonText(container);
        this.highlightSelectedFrequency(e.target);
      }
    });
  }

  updateButtonText(container) {
    // Find selected frequency and update button text accordingly
    const selectedPlan = container.querySelector('input[type="radio"]:checked');
    
    if (selectedPlan) {
      const planLabel = selectedPlan.parentNode.querySelector('label');
      const currentLang = document.documentElement.lang || 'en';
      
      if (planLabel) {
        const frequency = planLabel.textContent.trim();
        const baseText = container.getAttribute('data-subscription-text');
        const newText = `${baseText} - ${frequency}`;
        container.setAttribute('data-subscription-text', newText);
      }
    }
  }

  highlightSelectedFrequency(selectedRadio) {
    // Remove previous selections
    const container = selectedRadio.closest('#rc_selling_plans_for_subscription, [id*="rc_selling_plans_"]');
    container.querySelectorAll('.vinpop-frequency-label').forEach(label => {
      label.classList.remove('selected');
    });

    // Add selection to current
    const selectedLabel = selectedRadio.parentNode.querySelector('label');
    if (selectedLabel) {
      selectedLabel.classList.add('selected');
    }
  }

  observeSubscriptionChanges() {
    // Create a MutationObserver to watch for ReCharge widget changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const subscriptionWidget = node.querySelector('#rc_selling_plans_for_subscription, [id*="rc_selling_plans_"]');
              if (subscriptionWidget) {
                setTimeout(() => this.setupSubscriptionWidget(), 100);
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check periodically in case MutationObserver misses something
    setInterval(() => {
      const container = document.querySelector('#rc_selling_plans_for_subscription, [id*="rc_selling_plans_"]');
      if (container && !container.hasAttribute('data-frequency-heading')) {
        this.setupSubscriptionWidget();
      }
    }, 2000);
  }
}

// Initialize when script loads
new VinpopSubscriptionSelector();
